import React, { useState, useEffect, useRef } from 'react';

import ItemModal from './ItemModal'
import MasterItem from './MasterItem'
import ComponentToolbar from './ComponentToolbar'

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Tooltip from '@material-ui/core/Tooltip';

import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';

import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import FolderSpecialOutlinedIcon from '@material-ui/icons/FolderSpecialOutlined';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import { Input } from '@material-ui/core';

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.secondary.light,
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
  invetoryIcons: {
    flex: '1 1 30%',
  },
  invetorySpace: {
    width: '50px'
  }
}));

const MasterInventory = ({ inventory, setInventory }) => {
  const classes = useToolbarStyles();

  const [weight, setWeight] = useState(0)

  useEffect(() => {
    setWeight(calculateWeight())
  }, [inventory.items])

  const calculateWeight = () => {
    let totalWeight = 0
    inventory.items.map((item) => totalWeight += Number(item.weight) * item.quantity)
    return totalWeight
  }

  return (
    <React.Fragment>
      <ComponentToolbar
        title={"Inventario"}
      >
        <Grid item>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Typography>{inventory.money} &nbsp;</Typography>
            <AccountBalanceWalletOutlinedIcon />
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          // spacing={3}
          >
            <Typography>{weight} / {inventory.backpackWeight}&nbsp;</Typography>
            <FolderSpecialOutlinedIcon px={2} />
          </Grid>
        </Grid>
      </ComponentToolbar>

      <TableContainer
        className={classes.paper}
      >
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {/* <TableCell padding="checkbox"></TableCell> */}
              <TableCell>Nome</TableCell>
              <TableCell>Descrição</TableCell>
              <TableCell>Peso</TableCell>
              <TableCell align="right">Quantidade</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {inventory.items.map((item) => (
              <MasterItem
                key={item.name}
                name={item.name}
                description={item.description}
                weight={item.weight}
                quantity={item.quantity}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>


    </React.Fragment>
  );
}

export default MasterInventory;